import React, { useState, useEffect } from 'react';
import { VStack, Divider, Button, Box, Heading, HStack, Spacer, Icon, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FaCalendarAlt } from 'react-icons/fa';
import useAppointments from '../hooks/useAppointments';
import AppointmentsList from '../components/AppointmentsList';
import LoadingSpinner from '../components/LoadingSpinner';
import ErrorAlert from '../components/ErrorAlert';
import '../styles/pages/Dashboard.css';

const Dashboard = () => {
    const navigate = useNavigate();
    const { appointments, isLoading, error, fetchAppointments } = useAppointments();
    const [errorAlertVisible, setErrorAlertVisible] = useState(true);

    useEffect(() => {
        sessionStorage.removeItem('selectedType');
        sessionStorage.removeItem('slots');
        sessionStorage.removeItem('selectedAppointment');
    }, []);

    const handleBookingClick = () => {
        sessionStorage.removeItem('selectedType');
        sessionStorage.removeItem('slots');
        sessionStorage.removeItem('selectedAppointment');
        navigate('/book-appointment');
    };

    return (
        <Box className="dashboard-wrapper">
            <Box className="dashboard-container">
                {isLoading ? (
                    <LoadingSpinner />
                ) : error && errorAlertVisible ? (
                    <ErrorAlert
                        title="Error"
                        description={error}
                        onClose={() => setErrorAlertVisible(false)}
                    />
                ) : (
                    <VStack spacing={8} align="stretch">
                        <HStack className="dashboard-header">
                            <Heading size="lg" className="dashboard-title">Dashboard</Heading>
                            <Spacer />
                            <Button className="book-appointment-button" onClick={handleBookingClick}>
                                <Icon as={FaCalendarAlt} boxSize={5} className="calendar-icon" />
                                <Text className="book-appointment-text">Book Appointment</Text>
                            </Button>
                        </HStack>
                        <Divider className="dashboard-divider" />
                        
                        {appointments.planned && appointments.planned.length > 0 && (
                            <>
                                <AppointmentsList 
                                    appointments={appointments.planned} 
                                    title="Planned Appointments" 
                                    onAppointmentChange={fetchAppointments} 
                                    isPastAppointment={false} 
                                    isPlanned={true} 
                                />
                                <Divider className="dashboard-divider" />
                            </>
                        )}
                        
                        <>
                            <AppointmentsList 
                                appointments={appointments.upcoming} 
                                title="Upcoming Appointments" 
                                onAppointmentChange={fetchAppointments} 
                                isPastAppointment={false} 
                            />
                            <Divider className="dashboard-divider" />
                        </>
                        
                        {appointments.past && appointments.past.length > 0 && (
                            <>
                                <AppointmentsList 
                                    appointments={appointments.past} 
                                    title="Past Appointments" 
                                    isPastAppointment={true} 
                                />
                            </>
                        )}
                    </VStack>
                )}
            </Box>
        </Box>
    );
};

export default Dashboard;